import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Layout } from "@/config/antd";
import {
  selectUserProfile,
  selectIsSearching,
} from "@/store/redux/slices/user/user_slice";
import PageHeader from "@/components/layout/Header/Page_Header";
import HomeMessage from "@/pages/overview/components/HomeMessage";
import PriceCards from "@/pages/overview/components/PriceCards";
import HomeChart from "@/pages/overview/components/HomeChart";
import HomeCalender from "@/pages/overview/HomeCalender";
import OverviewEvents from "@/pages/overview/components/OverviewEvents";
import UpcomingEvents from "@/pages/overview/components/UpcomingEvents";
import AccountMembers from "@/pages/overview/components/AccountMembers";
import Breadcrumb from "@/components/specific/Breadcrumb";

const { Content } = Layout;

const Overview = () => {
  const userProfile = useSelector(selectUserProfile);
  const isSearching = useSelector(selectIsSearching);
  const navigate = useNavigate();

  // breadcrumb content
  const itemList = [{ title: "Home", link: "/dashboard" }];

  return (
    <Content className="py-4 sm:py-6 text-left sm:py-0 w-full">
      <div className="sm:px-4 md:px-6">
        <Breadcrumb itemList={itemList} />
        <PageHeader title="Dashboard" />
        <div className="w-full">
          <HomeMessage userProfile={userProfile} isSearching={isSearching} />
        </div>
        <div className="w-full">
          <PriceCards />
        </div>

        {/* First row with chart and calendar */}
        <div className="w-full grid grid-cols-1 gap-3 sm:gap-4 mb-4 sm:mb-5 lg:grid-cols-3">
          <div className="w-full col-span-1 lg:col-span-2">
            <HomeChart />
          </div>
          <div className="w-full col-span-1 border rounded-lg lg:border-transparent">
            <HomeCalender />
          </div>
        </div>

        {/* Second row with campaigns and events/members */}
        <div className="w-full grid grid-cols-1 gap-3 sm:gap-4 mb-4 sm:mb-5 lg:grid-cols-3">
          <div className="w-full col-span-1 lg:col-span-2">
            <div className="w-full flex items-center justify-between mb-3 sm:mb-4">
              <h2 className="text-2xl sm:text-3xl font-bold">
                Latest Campaigns
              </h2>
              <button
                className="text-sm font-medium text-primary cursor-pointer"
                onClick={() => navigate("/dashboard/events")}>
                View all
              </button>
            </div>
            <OverviewEvents />
          </div>
          <div className="w-full col-span-1">
            <div className="w-full mb-4 sm:mb-5">
              <UpcomingEvents />
            </div>
            <div className="w-full">
              <AccountMembers />
            </div>
          </div>
        </div>
      </div>
    </Content>
  );
};

export default Overview;
